<!--
 * @Descripttion: your project
 * @version: 1.0
 * @Author: CZK
 * @Date: 2024-12-11 11:16:02
 * @LastEditors: CZK
 * @LastEditTime: 2024-12-26 14:17:53
-->
<template>
  <div class="container">
    <div class="title-box">
      <p class="title">企业信息</p>
      <p class="desc">Hi，请填写以下资料吧~</p>
    </div>

    <div class="info-faren-main">
      <div class="tips">请上传证件彩色原件扫描图片或照片。支持jpg，jpeg，bmp或gif格式，单个文件大小10MB</div>
      <div class="body-box">
        <div class="info-faren-title-box">
          <p class="info-faren-title on">营业执照</p>
        </div>

      <div class='upload-company-box border-bottom-1px'>
        <div class="upload-company-show-image">
          <div class="default-image" @click="see(form.businessLicenseUrl)" v-if="form.businessLicenseUrl">
            <img :src="form.businessLicenseUrl" class="d"/>
          </div>

          <div class="default-image" v-else>
            <img src="../../assets/images/img/d-img.jpg" class="d"/>
            <div class="see-btn" @click="see()">
              <img src="../../assets/images/img/see.png"/>
              <span>查看样本</span>
            </div>
          </div>
        </div>

        <div class="upload-company-btn ">
          <OSSUpload 
          :type="form.idCard.uploadType"
          :backgroundImgName="form.idCard.bg" 
          :accept="form.idCard.accept"
          ref="upload1" 
          class="ossupload"
          :maxSize="10 * 1024 * 1024"
          :classType="true"
          :title="form.idCard.title"
          @success="(e)=>{return getCompanyUrl(e,'form')}"
          :files.sync="form.idCard.files" 
          :multiple="form.idCard.multiple"/>
          <button @click="upload" class="on">上传</button>
        </div>
      </div>
      <div class="tips" v-if="form.businessLicenseUrl">请确认以下信息是否正确，如有误请重新识别</div>

      <div class="faren-form" v-if="form.businessLicenseUrl">
        <div class="form-item border-bottom-1px">
          <label class="on">企业名称</label>
          <span>{{form.name}}</span>
        </div>
        <!-- <div class="form-item border-bottom-1px">
          <label class="on">企业简称</label>
          <input type="text" :maxlength="10" v-model="form.shortName" placeholder="请输入，不超过10个字">
        </div> -->
        <div class="form-item border-bottom-1px">
          <label class="on">企业类型</label>
          <span>{{form.enterpriseType}}</span>
        </div>
        <div class="form-item border-bottom-1px">
          <label class="on">统一社会信用代码</label>
          <span >{{form.creditCode}}</span>
        </div>
        <div class="form-item border-bottom-1px">
          <label class="on">成立时间</label>
          <span>{{form.validFromDate}}</span>
          
        </div>

        <div class="form-item border-bottom-1px">
          <label class="on">经营地址</label>
          <span>{{form.address}}</span>
        </div>
        <div class="form-item border-bottom-1px">
          <label class="on">国标行业代码</label>
          <input type="text" :maxlength="10" v-model="form.enterpriseTrade" placeholder="请输入国标行业代码">
        </div>
        <div class="tips_box">
          <span>查询国标行业代码，请点击<label @click="toQCC">企查查</label></span>
        </div>
      </div>
        <div class="add-btn on" v-if="form.businessLicenseUrl"  @click="commit">
          <cube-loading v-if="commiting"></cube-loading>
          <span>下一步</span>
        </div>
      </div>
    </div>

    <!-- <div class="info-faren-main">
      <div class="info-faren-title-box">
        <p class="info-faren-title on">企业联系人信息</p>
        <div class="select-box">
          <span @click="changeLianxiren"><i :class="{yes:lianxiren.contactStatus==1}"></i>同法人</span>
        </div>
      </div>

      <div class="info-faren-content">
        <OSSUpload 
        v-for="(item, index) in lianxiren.idCard" 
        :key="index" 
        :type="item.uploadType"   
        :backgroundImgName="item.bg" 
        :accept="item.accept" 
        @success="(e)=>{return handleSuccess(e,'lianxiren',index)}"
        ref="upload1" 
        :title="item.title" 
        :files.sync="item.files" 
        :multiple="item.multiple"/>
      </div>
      <div class="tips">请确认以下信息是否正确，如有误请重新识别</div>

      <div class="faren-form">
        <div class="form-item border-bottom-1px">
          <label>真实姓名</label>
          <span>{{lianxiren.name}}</span>
        </div>
        <div class="form-item border-bottom-1px">
          <label>身份证号</label>
          <span>{{lianxiren.idCardNo}}</span>
        </div>
        <div class="form-item border-bottom-1px">
          <label>签发机关</label>
          <span>{{lianxiren.signIssued}}</span>
        </div>
        <div class="form-item border-bottom-1px">
          <label>有效期限</label>
          <span>{{lianxiren.effectiveStartDate}}-{{lianxiren.effectiveEndDate}}</span>
        </div>
        <div class="form-item border-bottom-1px">
          <label>联系电话</label>
          <input type="text" :maxlength="11" v-model="lianxiren.phone" placeholder="请填写法人实名手机号">
        </div>
        <div class="form-item border-bottom-1px">
          <label>电子邮箱</label>
          <input type="text"  v-model="lianxiren.email" placeholder="请填写电子邮箱">
        </div>
      </div>
    </div> -->

      
  </div>
</template>
<script type="text/ecmascript-6">
import OSSUpload from "@comp/Upload/OSSUpload";
import { resetImageBlob } from "@/utils/getOssImageBlobUrl";
// import fontCard from '@comp/fontCard/index'
import {findNextFlowThenJump} from "./findNextFlow"
import moment from "moment";
import {uploadIdCard,saveEnterpriseInfo,getEnterpriseAuthInfo,recognizeBusinessLicense} from "@api/user";
export default {
  name: "",
  components: {
    // fontCard,
    OSSUpload
  },
  // 受益方式 1-直接或间接25%(含)以上 2-通过人事、财务等其他方对公司进行控制 3-高级管理员 4-法人或公司负责人 5-其他
  data(){
    return {
      form:{
        "address": "",
        "businessLicenseUrl": "",
        "creditCode": "",
        "enterpriseType": "",
        "validFromDate": "",
        "validToDate":'',
        "name": "",
        enterpriseTrade:"",
        // "shortName": "",
        idCard:
          {
            uploadType: 1,
            bg: "font_bg.png",
            accept: "image/png,image/jpeg,image/gif,image/bmp",
            // accept: ".xls,.xlsx,.csv",
            title: "上传营业执照",
            multiple: false,
            files: []
          },
        
      },
      identify:false,
      commiting:false
    }
  },
  methods: {
    toQCC(){
      window.open('https://www.qcc.com/')
    },
    async getInfo(){
     let res =  await getEnterpriseAuthInfo({token:""})
     if(res.success){
        const {address,backgroundIdCardUrl,expiresDate,headPhotoUrl,idCard,issueAuthority,name,phone,startDate,type} = res.data
        let keyName = type=='1'?'faren':'lianxiren'
        this[keyName].phone = phone
        this[keyName].signIssued  = issueAuthority
        this[keyName].idCardNo = idCard
        this[keyName].name = name
        this[keyName].identityFrontUrl = headPhotoUrl 
        this[keyName].identityReverseUrl = backgroundIdCardUrl
        this[keyName].effectiveStartDate = startDate
        this[keyName].effectiveEndDate = expiresDate
        if(headPhotoUrl){
          let imgurl = headPhotoUrl.replace('http://test-011.oss-cn-shenzhen.aliyuncs.com','')
          let utl = await resetImageBlob(imgurl)
          this.$set(this[keyName].idCard[0].files, 0, utl)
        }
        if(backgroundIdCardUrl){
          let imgurl1 = backgroundIdCardUrl.replace('http://test-011.oss-cn-shenzhen.aliyuncs.com','')
          let utl1 = await resetImageBlob(imgurl1)
          this.$set(this[keyName].idCard[1].files, 0, utl1)
        }
        
     }
    },
    see(url){
      const d_img = require('../../assets/images/img/d-img.jpg')
      url=url||d_img
      this.$createImagePreview({
        imgs: [url]
      }).show()
    },
    getCompanyUrl(e,KeyName,index){
      const {filenameUrl}=e
      this[KeyName].businessLicenseUrl=filenameUrl
      this.identify= false
      this.upload()
    },
    async upload(){

      // console.log(new Date('2017-12-12'),'时间')
      // return
      if(!this.form.businessLicenseUrl) return
      const toast = this.$createToast({txt: '识别中...',type: "loading",mask:true,time:999});
      toast.show()
      let res =  await recognizeBusinessLicense({businessLicenseUrl:this.form.businessLicenseUrl,token:''})
      if(res.success){
        const{data} = res
        const {businessAddress,businessScope,companyForm,companyName,companyType,creditCode,issueDate,
          legalPerson,registeredCapital,registrationDate,title,validFromDate,validPeriod,validToDate} = data

           this.form.address = businessAddress
           this.form.creditCode = creditCode
           this.form.enterpriseType = companyType
           this.form.validFromDate = validFromDate
           this.form.validToDate = validToDate
          //  this.form.foundTime = moment().format('YYYY-MM-DD')
           this.form.name = companyName
           this.identify= true
           setTimeout(() => {
            toast.hide()
           },1000)
        }
    },
    //法人 联系人
    async handleSuccess(e,KeyName,index){
      if(e.status == 'success'){
        const {filenameUrl}=e
        const toast = this.$createToast({txt: '识别中...',type: "loading",mask:true,time:999});
        toast.show()
        let res = await uploadIdCard({url:filenameUrl,token:''})
        toast.hide()
        if(res.success){
          const{data} = res
          if(data){
            const {address,birthDate,ethnicity,idNumber,issueAuthority,name,sex,type,validPeriod}=data
            if(type=='face'){
              this[KeyName].idCardNo = idNumber
              this[KeyName].name = name
              this[KeyName].identityFrontUrl = filenameUrl
            }else{
              const validPeriodDate = validPeriod.split('-')
              this[KeyName].effectiveStartDate = validPeriodDate[0].replace(/\./g,'-')
              this[KeyName].effectiveEndDate = validPeriodDate[1].replace(/\./g,'-')
              this[KeyName].signIssued = issueAuthority
              this[KeyName].identityReverseUrl = filenameUrl
            }
          }else{
            if(index==0){
              this[KeyName].idCardNo = ''
              this[KeyName].name = ''
              this[KeyName].identityFrontUrl = ''
            }else{
              this[KeyName].effectiveStartDate = ''
              this[KeyName].effectiveEndDate = ''
              this[KeyName].signIssued = ''
              this[KeyName].identityReverseUrl = ''
            }
            this.$createToast({txt: res.message,type: "error"}).show();
          }
        }else{
          this.$createToast({txt: '识别失败，请重试~',type: "error"}).show();
        }
        console.log(res,'识别结果')
      }else{
        this.$createToast({txt: '上传失败，请重试~',type: "error"}).show();
      }
    },
    async commit(){
      if(this.commiting) return;
      const{form}=this
      if(!form.businessLicenseUrl){
        return this.$createToast({txt: "请上传营业执照",type: "error"}).show();
      }

      // if(!form.shortName){
      //   return this.$createToast({txt: "请输入企业简称",type: "error"}).show();
      // }

      if(!form.enterpriseTrade){
        return this.$createToast({txt: "请输入国际行业代码",type: "error"}).show();
      }

      const companyInfo =  Object.keys(form).filter(key => key !== 'idCard').reduce((acc, key) => {
        acc[key] = form[key];
        return acc;
      }, {});

      // //检查手机号的合法性
      // if(!/^1[34578]\d{9}$/.test(faren.phone)){
      //   return this.$createToast({txt: "请输入正确的联系电话",type: "error"}).show();
      // }

      // if(!faren.email){
      //   return this.$createToast({txt: "请输入法人电子邮箱",type: "error"}).show();
      // }


      // // 检查邮箱的合法性
      // if(!/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(faren.email)){
      //   return this.$createToast({txt: "请输入正确的电子邮箱",type: "error"}).show();
      // }
      

     let res =  await saveEnterpriseInfo({
        ...companyInfo,token:''
      })

      if(res.success){
        findNextFlowThenJump()
      }
      this.commiting = false
    }
  },
  created(){
    // this.getInfo()
  }
}
</script>
<style lang="less" scoped>
input{
all: unset;
}
.container{
width: 100%;
background:#F5F7FB url("../../assets//images/img/bg1.png") no-repeat;
background-size: contain;
.title-box{
  margin-top: 27px;
  margin-left: 32px;
  .title{
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 24px;
    color: #FFFFFF;
    line-height: 18px;
  }
  .desc{
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #FFFFFF;
    line-height: 22px;
    margin-top: 12px;
  }
}
.info-faren-main{
  width: 343px;
  // height: 500px;
  background: #FFFFFF;
  margin: 17px auto 0;
  border-radius: 8px 8px 8px 8px;
  // padding: 14px 12px 12px;
  .upload-company-box{
    display:flex;
    flex-direction: column;
    align-items: center;
    // padding-bottom: 14px;
    .upload-company-btn{
      position: relative;
      width: 321px;
      height: 42px;
      display:flex;
      flex-direction: column;
      align-items: center;
      margin: 14px auto 14px;
      .ossupload{
        width:100%;
        height:100%;
        position:absolute;
        left:0;
        opacity: 0;
        top:0;
      }
      button{
        all:unset;
        width: 321px;
        height: 42px;
        text-align: center;
        background: #CCCCCC;
        border-radius: 30px 30px 30px 30px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 42px;
        color: #FFFFFF;
        &.on{
          background: linear-gradient( 270deg, #009DFF 2%, #0073FF 100%, #007AFF 100%);
          margin: 0 auto 0;
        }
      }
    }
    .upload-company-show-image{
      width: 321px;
      height: 124px;
      border-radius: 8px 8px 8px 8px;
      border: 2px dashed #C0DBFF;
      display:flex;
      justify-content:center;
      align-items: center;
      .default-image{
        width:159px;
        height:107px;
        overflow:hidden;
        display:flex;
        justify-content:center;
        align-items: center;
        position:relative;
        .d{
          width:100%;
          height:100%;
          object-fit:cover;
        }
        .see-btn{
          display:flex;
          flex-direction: column;
          justify-content:center;
          align-items: center;
          position:absolute;
          img{
            width:40px;
            height:40px;
            object-fit:contain;
          }
          span{
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #3399FF;
            line-height: 18px;
            margin-top:6px;
          }
        }
      }
    }
  }
  
  .tips{
    width: 100%;
    height: 60px;
    background: #FFFBE1;
    border-radius: 8px 8px 0px 0px;
    padding: 17px 12px;
    text-align: left;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #FFA54C;
    text-align: left;
    line-height:1.2;
  }
  .body-box{
    padding: 14px 12px 12px;
  }
  .info-faren-title-box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 13px;
    .select-box{
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      display: flex;
      line-height: 18px;
      span{display: flex;align-items: center;}
      i{
        display: inline-block;
        width: 16px;
        height: 16px;
        background: url("../../assets/images/img/no.png") no-repeat;
        background-size: contain;
        margin-left: 10px;
        margin-right: 10px;
        &.yes{
          background: url("../../assets/images/img/yes.png") no-repeat;
          background-size: contain;
        }
      }
    }
  }
  .info-faren-title{
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    margin-left: 5px;
    color: #1C2023;
    line-height: 20px;
    &.on{
      &::after{
        content: '*';
        color:#FA5151;
      }
    }
    
  }
  .info-faren-content{
    display: flex;
    flex-direction: column;
    align-items: center;
    button{
      all:unset;
      width: 321px;
      height: 42px;
      text-align: center;
      background: #CCCCCC;
      border-radius: 30px 30px 30px 30px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 42px;
      margin: 12px auto 0;
      color: #FFFFFF;
      &.on{
        background: linear-gradient( 270deg, #009DFF 2%, #0073FF 100%, #007AFF 100%);
        margin: 10px auto 16px;
      }
    }
    
  }
  // .tips{
  //   width: 321px;
  //   height: 40px;
  //   background: #FFFBE1;
  //   border-radius: 8px 8px 8px 8px;
  //   padding: 10px 0 10px 6px;
  //   text-align: left;
  //   font-family: PingFang SC, PingFang SC;
  //   font-weight: 500;
  //   font-size: 14px;
  //   margin: 14px 0;
  //   color: #FFA54C;
  // }
  .faren-form{
    .tips_box{
      display:flex;
      font-size: 12px;
      color:#999;
      margin:20px 0 20px 6px;
      label{
        color:#009DFF;
        margin-left: 4px;
      }
    }
    .form-item1{
      width: 100%;
      display: flex;
      justify-content: space-between;
      min-height: 50px;
      label{
        width: 56px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        flex-shrink: 0;
        color: #666666;
        margin-left: 6px;
        line-height: 50px;
        margin-right: 32px;
      }
      .types-box{
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        line-height: 18px;
        margin-top: 16px;
        p{
          display: flex;
          margin-bottom: 11px;
        }
        i{
          display: inline-block;
          width: 16px;
          height: 16px;
          flex-shrink: 0;
          background: url("../../assets/images/img/no.png") no-repeat;
          background-size: contain;
          margin-right: 10px;
          &.yes{
            background: url("../../assets/images/img/yes.png") no-repeat;
            background-size: contain;
          }
        }
      }
    }
    .form-item{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 50px;
      label{
        width: 56px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        flex-shrink: 0;
        color: #666666;
        margin-left: 6px;
        line-height: 20px;
        margin-right: 32px;
        
        &.on{
          position:relative;
          &::before{
            content: '*';
            position:absolute;
            left:-6px;
            top:0;
            color:#FA5151;
          }
        }
      }
      input{
        flex: 1;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        &::placeholder{
          color: #999999;
        }
      }
      span{
        flex: 1;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
      }
    }
  }
}

.add-btn{
    width: 321px;
    height: 42px;
    text-align: center;
    background: #CCCCCC;
    border-radius: 30px 30px 30px 30px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 42px;
    margin: 12px auto 0;
    color: #FFFFFF;
    &.on{
      background: linear-gradient( 270deg, #009DFF 2%, #0073FF 100%, #007AFF 100%);
      margin: 10px auto 16px;
    }
  }
}
</style>